module.exports = __webpack_public_path__ + "static/media/trash.b4330230.svg";